<template>
  <div>
    <slick-carousel
      v-if="conferenceDetail.images"
      :images="conferenceDetail.images"
    ></slick-carousel>
    <div class="conference-booking-detail">
      <div class="mb-4">
        <booking-status :value="1" class="mb-4 booking-status"></booking-status>
        <div class="conference-detail" v-if="conferenceDetail">
          <div class="conference-information">
            <div class="header cc-color mb-2">{{ conferenceDetail.title }}</div>
            <div class="header-detail mb-4">{{ conferenceDetail.detail }}</div>
            <div class="row mb-4">
              <div class="col-4 gap-col">
                <div class="detail">
                  <img :src="'/static/icons/clock-icon.svg'" alt="" />
                </div>
                <div class="title-detail">เวลาทำการ</div>
                <div class="detail">{{ conferenceDetail.timeLength }}</div>
              </div>
              <div class="col-4 gap-col">
                <div class="detail">
                  <img
                    :src="'/static/icons/person-icon.svg'"
                    alt=""
                    width="12px"
                  />
                </div>
                <div class="title-detail">ความจุห้อง</div>
                <div class="detail">{{ conferenceDetail.limit }}</div>
              </div>
              <div class="col-4 gap-col">
                <div class="detail">
                  <img :src="'/static/icons/area-icon.svg'" alt="" />
                </div>
                <div class="title-detail">ขนาดพื้นที่</div>
                <div class="detail">{{ conferenceDetail.usable }}</div>
              </div>
              <div class="col-12 gap-col">
                <div class="detail location in">
                  <img
                    :src="'/static/icons/location-pin-icon.svg'"
                    alt=""
                    width="15px"
                  />
                </div>
                <div class="title-detail location">สถานที่</div>
                <div class="detail">{{ conferenceDetail.address }}</div>
              </div>
            </div>
          </div>
          <div class="facility mt-3 mb-3">
            <div class="header-facility mb-4">บริการสิ่งอำนวยความสะดวก</div>
            <div class="row">
              <div
                v-for="(facility, indexFacility) in facilityList"
                :key="indexFacility"
                class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-6 facility-col"
              >
                <div class="detail">
                  <img :src="facility.icon" class="center" />
                </div>
                <div class="detail">{{ facility.name }}</div>
              </div>
            </div>
          </div>
          <div class="booking-select">
            <div class="header cc-color mb-2">จองห้องประชุม</div>
            <div class="header-detail">
              ระบุรายละเอียดห้องประชุมที่คุณต้องการ
              เมื่อทำการระบุรายละเอียดที่ตรงกับความต้องการของคุณเรียบร้อยแล้ว กด
              “ยืนยันการจอง” เพื่อเข้าสู่หน้าสรุปต่อไป
            </div>
          </div>
        </div>
      </div>
      <div class="booking-select mb-4">
        <booking-box-select
          :conferenceDetail="conferenceDetail"
        ></booking-box-select>
      </div>
      <div class="other">
        <div class="mt-3">
          <div class="other-cc">พื้นที่อื่นของ CC Conference</div>
          <booking-items
            :conferenceProjectList="conferenceProjectList"
            class="booking-item mb-4"
          ></booking-items>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BookingStatus from "../components/BookingStatus.vue";
import ScButton from "@/lib/components/ScButton";
import bookingBoxSelect from "../components/BookingBoxSelect";
import BookingItems from "../components/BookingItems";
import { baanRueJaiClient } from "@/dependencies";
import slickCarousel from "@/lib/components/slickCarousel";

export default {
  components: {
    "booking-status": BookingStatus,
    "sc-button": ScButton,
    "booking-box-select": bookingBoxSelect,
    "booking-items": BookingItems,
    "slick-carousel": slickCarousel,
  },
  data() {
    const facilityList = [
      {
        icon: "/static/icons/facility-icon/lcd-projector.svg",
        name: "LCD projector",
      },
      {
        icon: "/static/icons/facility-icon/mobile-screen.svg",
        name: "Mobile screen",
      },
      {
        icon: "/static/icons/facility-icon/clip-microphone.svg",
        name: "Clip microphone",
      },
      {
        icon: "/static/icons/facility-icon/wireless-microphone.svg",
        name: "Wireless microphone (1)",
      },
      {
        icon: "/static/icons/facility-icon/registration-table.svg",
        name: "Registration table",
      },
      {
        icon: "/static/icons/facility-icon/head-table.svg",
        name: "Head table",
      },
      {
        icon: "/static/icons/facility-icon/notepad-and-pencil.svg",
        name: "Notepad and pencil",
      },
      {
        icon: "/static/icons/facility-icon/flipchart.svg",
        name: "Flipchart",
      },
      {
        icon: "/static/icons/facility-icon/free-wifi.svg",
        name: "Free Wifi",
      },
    ];

    return {
      facilityList,
      conferenceProjectList: [],
      conferenceDetail: null
    };
  },
  created() {
    this.setupConferenceProjectDetail();
    this.setupConferenceProjectList();
  },
  methods: {
    async setupConferenceProjectDetail() {
      this.conferenceDetail = await this.fetchConference();
    },
    async setupConferenceProjectList() {
      this.conferenceProjectList = await this.fetchConferenceProjectList();
    },
    async fetchConferenceProjectList() {
      try {
        return await baanRueJaiClient.others.conference.getConferenceProjectList();
      } catch (err) {
        return [];
      }
    },
    async fetchConference() {
      const { conferenceId } = this.$route.params;

      try {
        return await baanRueJaiClient.others.conference.getConferenceById(
          conferenceId
        );
      } catch (err) {
        return [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";

.conference-booking-detail {
  width: 100%;
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 20px;
  padding-bottom: 10px;
  background-color: $white;
}

.conference-detail {
  text-align: left;
}

.other-cc {
  text-align: left;
  font-size: $font-24;
}

.other {
  border-top: 1px solid $color-light-gray-1;
}

.header {
  font-size: 32px;
  text-align: left;
}

.cc-color {
  color: $color-orange;
  font-weight: bold;
}

.title-detail {
  font-weight: bold;
  font-size: $font-18;
  display: inline;
  padding-left: 10px;
  margin-top: 15px;
}

.detail {
  padding-left: 12px;
  display: inline;
}

.gap-col {
  padding-bottom: 15px;
}

.in {
  padding-left: 16px;
}

.conference-information {
  border-bottom: 1px solid $color-light-gray-1;
}

.header-facility {
  font-size: $font-24;
}

.facility {
  padding-bottom: 25px;
  border-bottom: 3px solid $color-orange;
}

.facility-col {
  padding-bottom: 25px;
  display: grid;
  grid-template-columns: 50px auto;
}

.center {
  text-align: center;
}

.booking-item {
  padding-left: 6%;
  padding-right: 6%;
}

@media screen and (max-width: $m-size) {
  .detail,
  .title-detail {
    display: block;

    font-size: $font-14;
  }

  .gap-col {
    text-align: center;
    padding: 5px;
  }

  .location {
    display: inline-block;
  }

  .header-detail {
    font-size: $font-14;
  }

  .facility-col {
    text-align: center;
    display: block;
  }

  .booking-status {
    padding-left: 5%;
    padding-right: 5%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/other-web/Conference/pages/ConferenceBookingCreate.vue